import { getCoordsPoints } from '../utils/getCoordPoints'
import { PathSegment } from '../types/types'

export const generateGPXContent = (pathCoords: Array<PathSegment>, currentSequence: string[]) => {
  if (pathCoords.length === 0) return '';

  const points = getCoordsPoints(pathCoords);

  const gpxHeader = `<?xml version="1.0" encoding="UTF-8"?>
        <gpx version="1.1" creator="Puntos nodales" xmlns="http://www.topografix.com/GPX/1/1">
        <trk>
            <name>Ruta generada GPX</name>
            <trkseg>`;

  let gpxPoints = pathCoords
    .flatMap(segment => segment.path)
    .map(coord => `<trkpt lat="${coord.lat}" lon="${coord.lng}"></trkpt>`)
    .join('\n');

  points.forEach((point, i) => {
    gpxPoints += `<wpt lat="${point.lat}" lon="${point.lng}"><name>${currentSequence[i]}</name><desc></desc></wpt>\n`;
  });

  const gpxFooter = `
            </trkseg>
        </trk>
        </gpx>`;

  const gpxContent = gpxHeader + '\n' + gpxPoints + '\n' + gpxFooter;
  return gpxContent;
} 
